import { createSlice } from '@reduxjs/toolkit';

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    suggestSubscriptionAlert: false,
    suggestSubscriptionModal: false,
    requestedActionToUnlock: null,
  },
  reducers: {
    setSuggestSubscriptionAlert: (state, action) => {
      state.suggestSubscriptionAlert = action.payload;
    },
    setSuggestSubscriptionModal: (state, action) => {
      state.suggestSubscriptionModal = action.payload;
    },
    setRequestedActionToUnlock: (state, action) => {
      state.requestedActionToUnlock = action.payload;
    },
  },
});

export const { setSuggestSubscriptionAlert, setSuggestSubscriptionModal, setRequestedActionToUnlock } =
  subscriptionSlice.actions;

export default subscriptionSlice.reducer;
